import type { LogtoConfig } from "@logto/react";

/** DXM SSO redirects here after sign-in. Matches Builder's callback path. */
export const SIGN_IN_CALLBACK_PATH = "/oauth2/callback";

const DEFAULT_SCOPES = "openid profile email";

/**
 * DXM SSO (a Logto tenant) is the only sign-in. Deployed builds refuse to build without it (see
 * vite.config.ts); a local build may leave it unset and use /dev-login instead.
 */
export const dxmSsoConfig: LogtoConfig | undefined =
	import.meta.env.REACT_APP_DXM_SSO_ENDPOINT && import.meta.env.REACT_APP_DXM_SSO_APP_ID
		? {
				endpoint: import.meta.env.REACT_APP_DXM_SSO_ENDPOINT,
				appId: import.meta.env.REACT_APP_DXM_SSO_APP_ID,
				scopes: (import.meta.env.REACT_APP_DXM_SSO_SCOPES || DEFAULT_SCOPES).split(" ").filter(Boolean)
			}
		: undefined;

/**
 * Dev login is compiled into dev-server builds, like Builder's /dev-login route, and into the dev
 * deployment's build (REACT_APP_DEV_LOGIN, refused for stg and prod by vite.config.ts), where the API
 * also asks for its passphrase.
 */
export const DEV_LOGIN_AVAILABLE = import.meta.env.DEV || import.meta.env.REACT_APP_DEV_LOGIN === "true";
